import React, { Component } from "react";
import { withTranslation } from "react-i18next";

import Spinner from 'react-bootstrap/Spinner'

const utils = require("../auxiliar/aux_functions");
const { capitalize } = utils;

class Filters extends Component {

    state = {
        touched: this.props.touched,
        dataSource: this.props.dataSource,
        scientificName: this.props.scientificName,
        commonName: this.props.commonName,
        selectedHabitats: this.props.selectedHabitats,
        selectedTaxonomy: this.props.selectedTaxonomy
    };

    changeSelectedDataSource = e => {
        this.setState({
            dataSource: e.target.value,
            scientificName: "",
            commonName: "",
            selectedHabitats: [],
            selectedTaxonomy: ""
        });
    };

    checkDisabledBtn = () => {
        if (this.props.loading || this.props.filteringResults) {
            return true
        }
        if (
            this.state.scientificName === "" &&
            this.state.commonName === "" &&
            this.state.selectedTaxonomy === "" &&
            this.state.selectedHabitats.length === 0 &&
            !this.props.touched
        ) {
            return true
        }
        return false;
    };

    changeSelectedTaxonomy = e => {
        this.setState({
            selectedTaxonomy: e.target.value
        });
    };

    onCheckHabitat = e => {
        if (e.target.checked) {
            let newHabs = this.state.selectedHabitats;
            newHabs.push(e.target.id);
            this.setState({
                selectedHabitats: newHabs
            });
        } else {
            let newHabs = this.state.selectedHabitats.filter(
                h => h !== e.target.id
            );
            this.setState({
                selectedHabitats: newHabs
            });
        }
    };

    onChangeScientificName = e => {
        this.setState({
            scientificName: e.target.value
        });
    };

    onChangeCommonName = e => {
        this.setState({
            commonName: e.target.value
        });
    };

    onClickfilterBtn = () => {
        this.props.onFilter(this.state);
    };

    handleKeyDown = (e) => {
        if(e.keyCode === 13) {
            e.preventDefault()
            e.stopPropagation()
            this.props.onFilter(this.state);
        }
    }

    render() {

        const { t } = this.props

        return (
            <div className="col-md-12" id="filter">
                    <div className="col-xl-12 no-scroll" style={{margin: 0, padding: 0, maxHeight: 460, overflowY: 'scroll'}}>
                    <form style={{textAlign: 'center'}} onKeyDown={this.handleKeyDown}>
                        <div className="form-group" style={{marginBottom: 14, textAlign: 'left'}}>
                            <label
                                htmlFor="dataSource"
                                className="col-form-label offset-xl-1"
                            >
                                {t("filtro-fuenteDatos")}
                            </label>
                            <div className="col-xl-10 offset-xl-1 px-0">
                                <select
                                    className="form-control"
                                    id="dataSource"
                                    value={this.state.dataSource}
                                    onChange={this.changeSelectedDataSource}
                                    disabled={this.props.loading || this.props.filteringResults}
                                >
                                    <option key="BOTH" value="BOTH">
                                        SIBIC/EASIN
                                    </option>
                                    <option key="SIBIC" value="SIBIC">
                                        SIBIC
                                    </option>
                                    <option key="EASIN" value="EASIN">
                                        EASIN
                                    </option>
                                </select>
                            </div>
                        </div>

                        {
                            this.state.dataSource === "BOTH" ? this.renderBothFilters():
                                this.state.dataSource === "SIBIC" ? this.renderSibicFilters() : this.renderEasinFilters()
                        }

                        <button
                            type="button"
                            className={this.checkDisabledBtn() ? "btn btn-primary col-xl-11 disabled-filter-btn": "btn btn-primary col-xl-11"}
                            disabled={this.checkDisabledBtn()}
                            onClick={this.onClickfilterBtn}
                        >
                            <strong>{t("filtro-btnBuscar-1")}</strong> {t("filtro-btnBuscar-2")}
                        </button>
                    </form>
                    </div>
            </div>
        );
    }

    renderSibicFilters = () => {

        const { t } = this.props

        return (
            <>
            <div className="form-group" style={{marginBottom: 14, textAlign: 'left'}}>
                <label
                    className="col-form-label offset-xl-1"
                    htmlFor="nombreCientifico"
                >
                    {t("filtro-nombreCien")}
                </label>
                <input
                    disabled={this.props.loading || this.props.filteringResults}
                    value={this.state.scientificName}
                    onChange={this.onChangeScientificName}
                    type="text"
                    className="form-control col-xl-10 offset-xl-1"
                    id="scientificName"
                    placeholder={t("filtro-placeholder-1")}
                />
            </div>
            <div className="form-group" style={{marginBottom: 14, textAlign: 'left'}}>
                <label
                    className="col-form-label offset-xl-1"
                    htmlFor="nombreComun"
                >
                    {t("filtro-nombreCom")}
                </label>
                <input
                    disabled={this.props.loading || this.props.filteringResults}
                    value={this.state.commonName}
                    onChange={this.onChangeCommonName}
                    type="text"
                    className="form-control col-xl-10 offset-xl-1"
                    id="nombreComun"
                    placeholder={t("filtro-placeholder-1")}
                />
            </div>
            <div className="form-group" style={{marginBottom: 14, textAlign: 'left'}}>
                <label className="col-form-label offset-xl-1">{t("filtro-entorno")}</label>
                <div className="col-xl-10 offset-xl-1" style={{paddingLeft: 0}}>
                    {this.props.loading
                        ? <MiniSpinner/>
                        : this.props.habitatsSIBIC.map((hab, i) => {
                              return (
                                  <div
                                      key={hab.habitat_id}
                                      className="form-check form-check-inline "
                                  >
                                      <input
                                          checked={
                                              this.state.selectedHabitats.indexOf(
                                                  hab.habitat_id
                                              ) !== -1
                                          }
                                          onChange={
                                              this.onCheckHabitat
                                          }
                                          className="form-check-input"
                                          type="checkbox"
                                          id={hab.habitat_id}
                                          name={hab.habitat_id}
                                          value={hab.habitat_id}
                                          disabled={this.props.filteringResults}
                                      />
                                      <label
                                          className="form-check-label"
                                          htmlFor={hab.habitat_id}
                                      >
                                          {capitalize(hab.habitat)}
                                      </label>
                                  </div>
                              );
                          })}
                </div>
            </div>
            <div className="form-group" style={{marginBottom: 14, textAlign: 'left'}}>
                <label
                    htmlFor="taxonomia"
                    className="col-form-label offset-xl-1"
                >
                    {t("filtro-taxonomia")}
                </label>
                <div className="col-xl-10 offset-xl-1 px-0">
                    <select
                        className="form-control"
                        id="taxonomia"
                        value={this.state.selectedTaxonomy}
                        onChange={this.changeSelectedTaxonomy}
                        disabled={this.props.loading || this.props.filteringResults}
                    >
                        <option value="">
                            {t("filtro-placeholder-2")}
                        </option>
                        {this.props.taxonomiesSIBIC.map((tax, i) => {
                            return (
                                <option
                                    key={tax.taxonomic_group}
                                    value={tax.taxonomic_group}
                                >
                                    {tax.taxonomic_group}
                                </option>
                            );
                        })}
                    </select>
                </div>
            </div>
            </>
        )
    }

    renderBothFilters = () => {

        const { t } = this.props

        return (
            <div className="form-group" style={{marginBottom: 14, textAlign: 'left'}}>
                <label
                    className="col-form-label offset-xl-1"
                    htmlFor="nombreCientifico"
                >
                    {t("filtro-nombreCien")}
                </label>
                <input
                    disabled={this.props.loading || this.props.filteringResults}
                    value={this.state.scientificName}
                    onChange={this.onChangeScientificName}
                    type="text"
                    className="form-control col-xl-10 offset-xl-1"
                    id="scientificName"
                    placeholder={t("filtro-placeholder-1")}
                />
            </div>
        )
    }

    renderEasinFilters = () => {

        const { t } = this.props

        return (
            <>
            <div className="form-group" style={{marginBottom: 14, textAlign: 'left'}}>
                <label
                    className="col-form-label offset-xl-1"
                    htmlFor="nombreCientifico"
                >
                    {t("filtro-nombreCien")}
                </label>
                <input
                    disabled={this.props.loading || this.props.filteringResults}
                    value={this.state.scientificName}
                    onChange={this.onChangeScientificName}
                    type="text"
                    className="form-control col-xl-10 offset-xl-1"
                    id="scientificName"
                    placeholder={t("filtro-placeholder-1")}
                />
            </div>
            <div className="form-group" style={{marginBottom: 14, textAlign: 'left'}}>
                <label className="col-form-label offset-xl-1">{t("filtro-entorno")}</label>
                <div className="col-xl-10 offset-xl-1" style={{paddingLeft: 0}}>
                    {this.props.loading
                        ? <MiniSpinner/>
                        : this.props.habitatsEASIN.map((hab, i) => {
                              return (
                                  <div
                                      key={hab.environmentId}
                                      className="form-check form-check-inline "
                                  >
                                      <input
                                          checked={
                                              this.state.selectedHabitats.indexOf(
                                                  hab.environmentId
                                              ) !== -1
                                          }
                                          onChange={
                                              this.onCheckHabitat
                                          }
                                          className="form-check-input"
                                          type="checkbox"
                                          id={hab.environmentId}
                                          name={hab.environmentId}
                                          value={hab.environmentId}
                                          disabled={this.props.filteringResults}
                                      />
                                      <label
                                          className="form-check-label"
                                          htmlFor={hab.environmentId}
                                      >
                                          {capitalize(hab.description)}
                                      </label>
                                  </div>
                              );
                          })}
                </div>
            </div>
            <div className="form-group" style={{marginBottom: 14, textAlign: 'left'}}>
                <label
                    htmlFor="taxonomia"
                    className="col-form-label offset-xl-1"
                >
                    {t("filtro-taxonomia")}
                </label>
                <div className="col-xl-10 offset-xl-1 px-0">
                    <select
                        className="form-control"
                        id="taxonomia"
                        value={this.state.selectedTaxonomy}
                        onChange={this.changeSelectedTaxonomy}
                        disabled={this.props.loading || this.props.filteringResults}
                    >
                        <option value="">
                            {t("filtro-placeholder-2")}
                        </option>
                        {this.props.taxonomiesEASIN.map((tax, i) => {
                            return (
                                <option
                                    key={tax.family}
                                    value={tax.family}
                                >
                                    {tax.family}
                                </option>
                            );
                        })}
                    </select>
                </div>
            </div>
            </>
        )
    }


}

export default withTranslation()(Filters);

const MiniSpinner = props => (
        <div style={{display: 'flex'}}>
            <Spinner animation="grow" size="sm" variant="secondary" style={{marginRight: 5}}/>
            <Spinner animation="grow" size="sm" variant="secondary" style={{marginRight: 5}}/>
            <Spinner animation="grow" size="sm" variant="secondary" />
        </div>
)
